import { KNOWLEDGE_LESSONS } from './types';

interface GameHUDProps {
  score: number;
  round: number;
  totalRounds: number;
  cleanBar: number;
  bacteriaBar: number;
  cookedBar: number;
  onNotebook: () => void;
}

export default function GameHUD({ score, round, totalRounds, cleanBar, bacteriaBar, cookedBar, onNotebook }: GameHUDProps) {
  return (
    <div className="bg-white/90 backdrop-blur-sm border-b border-amber-100 px-4 py-3 flex flex-wrap items-center gap-3 sticky top-0 z-20">
      {/* Progress */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-map-pin-2-fill text-primary-orange text-sm"></i>
        </div>
        <div className="flex gap-1">
          {Array.from({ length: totalRounds }).map((_, i) => (
            <div
              key={i}
              className={`h-2 rounded-full transition-all ${
                i < round ? 'w-5 bg-primary-orange' : i === round ? 'w-5 bg-amber-300 animate-pulse' : 'w-3 bg-gray-200'
              }`}
            />
          ))}
        </div>
        <span className="text-xs font-bold text-primary-brown-dark">Vòng {round + 1}/{totalRounds}</span>
      </div>

      <div className="flex-1 flex items-center gap-4 flex-wrap">
        {/* Clean Bar */}
        <div className="flex items-center gap-1.5 min-w-32">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-drop-fill text-sky-500 text-sm"></i>
          </div>
          <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-sky-400 to-blue-400 rounded-full transition-all duration-500"
              style={{ width: `${cleanBar}%` }}
            />
          </div>
          <span className="text-xs font-bold text-sky-600 w-8">{Math.round(cleanBar)}%</span>
        </div>

        {/* Bacteria Bar */}
        <div className="flex items-center gap-1.5 min-w-32">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <span className="text-xs">🦠</span>
          </div>
          <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-red-400 to-rose-500 rounded-full transition-all duration-500"
              style={{ width: `${bacteriaBar}%` }}
            />
          </div>
          <span className="text-xs font-bold text-red-600 w-8">{Math.round(bacteriaBar)}%</span>
        </div>

        {/* Cooked Bar */}
        <div className="flex items-center gap-1.5 min-w-32">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <span className="text-xs">🌡️</span>
          </div>
          <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-amber-400 to-orange-500 rounded-full transition-all duration-500"
              style={{ width: `${cookedBar}%` }}
            />
          </div>
          <span className="text-xs font-bold text-amber-600 w-8">{Math.round(cookedBar)}%</span>
        </div>
      </div>

      {/* Score */}
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1.5 bg-primary-orange/10 px-3 py-1.5 rounded-full">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-star-fill text-primary-orange text-xs"></i>
          </div>
          <span className="text-sm font-extrabold text-primary-orange">{score}</span>
        </div>
        <button
          onClick={onNotebook}
          className="flex items-center gap-1.5 bg-amber-50 border border-amber-200 px-3 py-1.5 rounded-full cursor-pointer hover:bg-amber-100 transition-all whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-book-2-line text-amber-600 text-xs"></i>
          </div>
          <span className="text-xs font-bold text-amber-700">Sổ tay</span>
          <span className="bg-amber-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
            {KNOWLEDGE_LESSONS.filter(l => l.id < round).length}
          </span>
        </button>
      </div>
    </div>
  );
}
